/**
 * Exchange the platform login token from `?accessToken=` for a session cookie.
 *
 * The server accepts each token once. A repeated call — the exchange effect
 * re-running after an earlier call already set the cookie — gets 409, which is
 * not a failure: the caller continues with the cookie and lets `/api/me` decide
 * whether the user is signed in. Every other error is rethrown.
 */
export async function exchangeLoginToken(
  exchange: (accessToken: string) => Promise<unknown>,
  accessToken: string,
): Promise<'exchanged' | 'already_used'> {
  try {
    await exchange(accessToken);
    return 'exchanged';
  } catch (err) {
    if ((err as { status?: unknown } | null)?.status === 409) return 'already_used';
    throw err;
  }
}
